<template>
  <div>
    <h3 style="font-size: 36px; margin-bottom: 0px;">{{ blogName }}</h3>
    <div class="hline mb-3"></div>
    <div v-if="blogName == '교육결과물'">
      <ReportList
        v-for="article in articles[blogName]"
        :key="article.id"
        :report="article"
      ></ReportList>
    </div>
    <div v-else-if="blogName == '기술블로그'">
      <ul>
        <li v-for="article in articles[blogName]" :key="article.id">
          <a :href="article.url">{{ article.title }}</a>
        </li>
      </ul>
    </div>
    <div v-else>
      <BlogCard
        v-for="article in articles[blogName]"
        :key="article.id"
        :article="article"
      ></BlogCard>
    </div>
  </div>
</template>

<script>
import BlogCard from "@/components/blog-components/BlogCard.vue";
import ReportList from "@/components/portfolio-components/ReportList.vue";
export default {
  components: {
    BlogCard,
    ReportList
  },
  props: {
    blogName: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      articles: {
        교육블로그: [
          {
            id: 1,
            title: "회고: 지금까지의 인스티튜트들 by 윤성관",
            url:
              "https://codershigh.dscloud.biz/edublogs/eb_003_ade_flashback/eb003_script.html"
          },
          {
            id: 2,
            title: "ADE Global Institute 2018 Austin을 다녀와서 by 윤성관",
            url:
              "https://codershigh.dscloud.biz/edublogs/eb_002_ade_austin/eb002_script.html"
          },
          {
            id: 3,
            title: "코더스하이 커리큘럼 회의 리뷰 by 윤성관",
            url:
              "https://codershigh.dscloud.biz/edublogs/eb_001_chc005review/eb001_script.html"
          }
        ],
        기술블로그: [
          {
            id: 4,
            title: "TJBot IBM Dev Day by 윤성관",
            url:
              "https://codershigh.dscloud.biz/techblogs/tb_010_IBMDevDay/tb0010_script.html"
          },
          {
            id: 5,
            title: "UISearchController로 검색 개발하기 by 송동욱",
            url:
              "https://codershigh.dscloud.biz/techblogs/tb_009_UISearchController/tb009_script.html"
          },
          {
            id: 6,
            title: "3d 스크롤이 가능한 태그 클라우드 만들기 by 김소연",
            url:
              "https://codershigh.dscloud.biz/techblogs/tb_008_tagCloud/tb008_script.html"
          },
          {
            id: 7,
            title:
              "네이버 오픈 API를 이용한 영화 검색 애플리케이션 만들기 by 김수진",
            url:
              "https://codershigh.dscloud.biz/techblogs/tb_007_movieSearcher/tb007_script.html"
          },
          {
            id: 8,
            title: "플레이그라운드 북 만들기 by 윤성관",
            url:
              "https://codershigh.dscloud.biz/techblogs/tb_005_playgroundbook/tb005_script.html"
          },
          {
            id: 9,
            title: "Firebase를 이용하여 Timeline만들기 by 박병욱",
            url:
              "https://codershigh.dscloud.biz/techblogs/tb_004_firebaseTimeline/tb004_script.html"
          },
          {
            id: 10,
            title: "Firebase를 이용하여 채팅창 만들기 by 박현수",
            url:
              "https://codershigh.dscloud.biz/techblogs/tb_003_firebaseChat/tb003_script.html"
          },
          {
            id: 11,
            title: "ReplayKit을 이용해 여행 떠나기 by 유준영",
            url:
              "https://codershigh.dscloud.biz/techblogs/tb_002_replykit/tb002_script.html"
          },
          {
            id: 12,
            title: "메시지 익스텐션을 이용한 Calendar-Vot 제작기",
            url:
              "http://codershigh.dscloud.biz/wordpress/2020/03/01/%eb%a9%94%ec%8b%9c%ec%a7%80-%ec%9d%b5%ec%8a%a4%ed%85%90%ec%85%98%ec%9d%84-%ec%9d%b4%ec%9a%a9%ed%95%9c-calendar-vot-%ec%a0%9c%ec%9e%91%ea%b8%b0/"
          }
        ],
        교육결과물: [
          // 리스트에 타이틀을 추가합니다.
          {
            id: 12116,
            title: "2021 겨울방학 동국대학교 iOS 머신러닝 앱 개발 과정",
            url: ""
          },
          {
            id: 12115,
            title: "2020 온라인스쿨 3기",
            url: ""
          },
          {
            id: 12114,
            title: "2020 드림인 iOS 아카데미",
            url: ""
          },
          {
            id: 12113,
            title: "2020 1학기 한동대학교 iOS 앱 개발 코스",
            url: ""
          },
          {
            id: 1211,
            title: "2020 1학기 한양대학교 iOS App Design to Develop Course",
            url: ""
          },
          {
            id: 121,
            title: "2020 겨울방학 동국대학교 iOS 머신러닝 앱 개발 과정",
            url: ""
          },
          {
            id: 13,
            title: "2019 여름방학 광운대학교 iOS 특강",
            url: ""
          },
          {
            id: 131,
            title: "2019 1학기 한양대학교 공과대학 컴퓨터/SW 전공",
            url: ""
          },
          {
            id: 14,
            title: "2019 1학기 연세대학교 UIC IID 학과",
            url: ""
          },
          {
            id: 15,
            title: "2019 겨울방학 중앙대학교 iOS 특강",
            url: ""
          },
          {
            id: 16,
            title: "2019 겨울방학 동국대학교 iOS 특강",
            url: ""
          },
          {
            id: 17,
            title: "2018 여름방학 중앙대학교 iOS 특강",
            url: ""
          },
          {
            id: 18,
            title: "2018 여름방학 고려대학교 iOS 특강",
            url: ""
          },
          {
            id: 20,
            title: "결과물 더 보기",
            url: "/portfolio"
          }
        ]
      }
    };
  }
};
</script>

<style scoped>
ul {
  list-style-type: none;
  padding-left: 0px;
}
li {
  margin-bottom: 8px;
}
</style>
